/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 12.07.13
 * Time: 11:39
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

export class JSReadURLParameterLogLOFactory extends BasicLogObjectFactory {
    public static JAVASCRIPT_READ_URL_PARAMETERS_FAILED_LOG: number = 30001;

    private static EXTERNAL_ERROR: number = 30;
    private static PARAM_USER_INFO_DATA: string = "userInfoData";

    private _userInfoData: string;

    constructor(subErrorId: number, userInfoData: string) {
        super();

        this._subErrorId = subErrorId;
        this._userInfoData = userInfoData;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Set custom data
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, JSReadURLParameterLogLOFactory.EXTERNAL_ERROR.toString());
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_TYPE, ExternalLoggingConstants.LOGGING_TYPE_LOG.toString());
        lo.logData.set(JSReadURLParameterLogLOFactory.PARAM_USER_INFO_DATA, this._userInfoData.toString());

        return lo;
    }
}
